import "swiper/swiper-bundle.css";

import { Autoplay, Navigation, Pagination } from "swiper/modules";

import Swiper from "swiper";

Array.from(document.querySelectorAll("section.featured-articles .swiper")).map(
	(hero) => {
		const swiper = new Swiper(hero, {
			modules: [Autoplay, Pagination, Navigation],
			fadeEffect: {
				crossFade: true,
			},
			autoplay: {
				delay: 7500,
			},
			slidesPerView: 1.25,
			spaceBetween: 12,
			loop: true,
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
			breakpoints: {
				768: {
					slidesPerView: 1.25,
					spaceBetween: 24,
				},
				1200: {
					slidesPerView: 3.5,
					spaceBetween: 24,
				},
			},
		});
	}
);
